import { Routes } from '@/router/routes'

import { AppPermissions } from '@/types/enums/permissions/permissions'
import { Middleware } from '@/types/enums/middleware/middleware'

export const deviationsRoutes = [
  {
    path: '/deviations',
    name: Routes.Deviations,
    component: () => import('@/pages/contexts/portal/deviations/Index.vue'),
    meta: {
      pageTitle: 'Manage Deviations',
      middleware: [
        Middleware.REQUIRES_AUTH,
        Middleware.TOGGLES_NAV_DRAWER,
      ],
      permission: AppPermissions.VIEW_DEVIATIONS,
    },
    children: [
      {
        path: 'create',
        name: Routes.CreateDeviation,
        component: () => import('@/pages/contexts/portal/deviations/Create.vue'),
        meta: {
          middleware: [
            Middleware.REQUIRES_AUTH,
            Middleware.TOGGLES_NAV_DRAWER,
          ],
          permission: AppPermissions.VIEW_DEVIATIONS,
        },
      },
      {
        path: 'view/:deviationId',
        name: Routes.ViewDeviation,
        component: () => import('@/pages/contexts/portal/deviations/View.vue'),
        meta: {
          middleware: [
            Middleware.REQUIRES_AUTH,
            Middleware.TOGGLES_NAV_DRAWER,
          ],
          permission: AppPermissions.VIEW_DEVIATIONS,
        },
      },
    ],
  },
]
